var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCampaigns, updateCampaign } from "../../actions/dashboards";
import Select from "react-select";
import ProgressLoader from "../../components/layout/ProgressLoader"; // substituído aqui
var OBJECTIVES = [
    { value: "vendas", label: "Vendas" },
    { value: "alcance", label: "Alcance" },
    { value: "seguidores", label: "Seguidores" },
    { value: "site", label: "Tráfego para o site" },
    { value: "engajamento", label: "Engajamento" },
    // Adicione outros objetivos conforme necessário
];
var customStyles = {
    control: function (provided) { return (__assign(__assign({}, provided), { backgroundColor: "#1e293b", color: "#fff", borderRadius: 8, borderColor: "#334155", minHeight: 44, boxShadow: "none", fontSize: 18 })); },
    menu: function (provided) { return (__assign(__assign({}, provided), { backgroundColor: "#1e293b", color: "#fff", borderRadius: 8, fontSize: 16 })); },
    singleValue: function (provided) { return (__assign(__assign({}, provided), { color: "#fff" })); },
    option: function (provided, state) { return (__assign(__assign({}, provided), { backgroundColor: state.isSelected
            ? "#2563eb"
            : state.isFocused
                ? "#334155"
                : "#1e293b", color: "#fff", fontWeight: state.isSelected ? "bold" : "normal", cursor: "pointer" })); },
    placeholder: function (provided) { return (__assign(__assign({}, provided), { color: "#94a3b8" })); },
};
var DashboardSettings = function () {
    var _a = useParams(), id = _a.id, name = _a.name;
    var clientId = id || "";
    var _b = useState([]), campaigns = _b[0], setCampaigns = _b[1];
    var _c = useState({}), originalDescriptions = _c[0], setOriginalDescriptions = _c[1];
    var _d = useState(true), loading = _d[0], setLoading = _d[1];
    useEffect(function () {
        var fetchCampaigns = function () { return __awaiter(void 0, void 0, void 0, function () {
            var res, descs_1, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setLoading(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getCampaigns(clientId)];
                    case 2:
                        res = _b.sent();
                        setCampaigns(res.data); // Não sobrescreva o is_active!
                        descs_1 = {};
                        res.data.forEach(function (c) {
                            descs_1[c.id] = c.description || "";
                        });
                        setOriginalDescriptions(descs_1);
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        setCampaigns([]);
                        return [3 /*break*/, 4];
                    case 4:
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        fetchCampaigns();
    }, [clientId]);
    var handleChange = function (id, field, value) { return __awaiter(void 0, void 0, void 0, function () {
        var campaign;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(field === "is_active")) return [3 /*break*/, 3];
                    setCampaigns(function (prev) {
                        return prev.map(function (c) {
                            var _a;
                            return (c.id === id ? __assign(__assign({}, c), (_a = {}, _a[field] = value, _a)) : c);
                        });
                    });
                    campaign = campaigns.find(function (c) { return c.id === id; });
                    if (!campaign) return [3 /*break*/, 2];
                    return [4 /*yield*/, updateCampaign(clientId, campaign.id, {
                            platform: campaign.platform,
                            is_active: value, // <-- use o novo valor aqui!
                            name: campaign.name,
                            objective: campaign.objective,
                            description: campaign.description,
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
                case 3:
                    // Para outros campos, só atualiza o estado local
                    setCampaigns(function (prev) {
                        return prev.map(function (c) {
                            var _a;
                            return (c.id === id ? __assign(__assign({}, c), (_a = {}, _a[field] = value, _a)) : c);
                        });
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSave = function (campaign) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!campaign.is_active) return [3 /*break*/, 2];
                    return [4 /*yield*/, updateCampaign(clientId, campaign.id, {
                            platform: campaign.platform,
                            is_active: true,
                            objective: campaign.objective,
                            description: campaign.description,
                        })];
                case 1:
                    _a.sent();
                    setOriginalDescriptions(function (prev) {
                        var _a;
                        return (__assign(__assign({}, prev), (_a = {}, _a[campaign.id] = campaign.description || "", _a)));
                    });
                    return [3 /*break*/, 4];
                case 2: 
                // Se está inativa, envie apenas is_active e plataforma
                return [4 /*yield*/, updateCampaign(clientId, campaign.id, {
                        platform: campaign.platform,
                        is_active: false,
                    })];
                case 3:
                    // Se está inativa, envie apenas is_active e plataforma
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // Removido instagram
    var groupedCampaigns = {
        google: campaigns.filter(function (c) { return c.platform === "google"; }),
        facebook: campaigns.filter(function (c) { return c.platform === "facebook"; }),
    };
    if (!clientId) {
        return (React.createElement("div", { className: "min-h-screen flex items-center justify-center text-red-400" }, "ID do cliente n\u00E3o informado na URL."));
    }
    if (loading)
        return (React.createElement(ProgressLoader, { message: "Carregando campanhas..." }));
    return (React.createElement("div", { className: "min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white" },
        React.createElement("div", { className: "w-full bg-gradient-to-r from-blue-500 to-cyan-400 py-2 px-8 flex justify-between items-center" },
            React.createElement("span", { className: "font-semibold tracking-widest text-sm uppercase" }, "Configura\u00E7\u00F5es das Campanhas"),
            React.createElement("a", { href: "/dashboards/".concat(name, "/").concat(id), className: "flex items-center gap-2 text-xs bg-blue-700 hover:bg-blue-800 px-3 py-1 rounded transition", title: "Voltar ao Dashboard" }, "Voltar")),
        React.createElement("div", { className: "max-w-3xl mx-auto p-4" },
            React.createElement("h2", { className: "text-2xl font-bold mb-6 text-center text-cyan-300 drop-shadow-lg" }, "Configura\u00E7\u00F5es das Campanhas"),
            Object.entries(groupedCampaigns).map(function (_a) {
                var platform = _a[0], group = _a[1];
                return group.length > 0 && (React.createElement("div", { key: platform, className: "mb-12" },
                    React.createElement("div", { className: "\n                  flex items-center gap-2 px-6 py-2 rounded-t-lg font-bold text-lg mb-0\n                  ".concat(platform === "google" ? "bg-green-600 text-white" : "", "\n                  ").concat(platform === "facebook" ? "bg-blue-700 text-white" : "", "\n                ") },
                        platform === "google" && (React.createElement("svg", { className: "w-6 h-6", fill: "white", viewBox: "0 0 24 24" },
                            React.createElement("text", { x: "3", y: "19", fontSize: "18", fontWeight: "bold" }, "G"))),
                        platform === "facebook" && (React.createElement("svg", { className: "w-6 h-6", fill: "white", viewBox: "0 0 24 24" },
                            React.createElement("text", { x: "3", y: "19", fontSize: "18", fontWeight: "bold" }, "f"))),
                        React.createElement("span", { className: "uppercase tracking-wider" },
                            platform === "google" && "Google Ads",
                            platform === "facebook" && "Facebook Ads")),
                    group.map(function (campaign) {
                        var descriptionChanged = (campaign.description || "") !== (originalDescriptions[campaign.id] || "");
                        return (React.createElement("div", { key: campaign.id, className: "relative bg-gray-900/80 rounded-lg px-6 pt-2 pb-0.5 mb-2 shadow-lg transition-opacity duration-200 ".concat(!campaign.is_active ? "opacity-40" : "") },
                            React.createElement("div", { className: "flex items-center gap-4 font-semibold text-lg mb-6" },
                                React.createElement("span", { className: "text-cyan-200 text-lg font-extrabold tracking-tight break-all flex-1" }, campaign.name)),
                            React.createElement("div", { className: "absolute top-3 right-6 flex flex-col items-center" },
                                React.createElement("button", { type: "button", className: "w-9 h-4 rounded-full flex items-center transition-colors duration-300 focus:outline-none ".concat(campaign.is_active ? "bg-green-500" : "bg-gray-600"), onClick: function () {
                                        return handleChange(campaign.id, "is_active", !campaign.is_active);
                                    } },
                                    React.createElement("span", { className: "w-5 h-5 bg-white rounded-full shadow transform transition-transform duration-300 ".concat(campaign.is_active ? "translate-x-5" : "translate-x-1") })),
                                React.createElement("span", { className: "text-xs mt-1 text-gray-300" }, campaign.is_active ? "Ativa" : "Inativa")),
                            campaign.is_active && (React.createElement("div", { className: "flex flex-col md:flex-row gap-4 items-center mt-4" },
                                React.createElement("div", null,
                                    React.createElement(Select, { options: __spreadArray([
                                            { value: "", label: "Selecione o objetivo" }
                                        ], OBJECTIVES, true), styles: customStyles, placeholder: "Selecione o objetivo", value: OBJECTIVES.find(function (obj) { return obj.value === campaign.objective; }) ||
                                            { value: "", label: "Selecione o objetivo" }, onChange: function (selected) {
                                            return handleChange(campaign.id, "objective", selected ? selected.value : "");
                                        } })),
                                React.createElement("div", { className: "flex-1" },
                                    React.createElement("textarea", { className: "bg-[#1e293b] text-white rounded-lg px-4 py-3 w-full border border-[#334155] focus:outline-none focus:ring-2 focus:ring-cyan-400 transition placeholder:text-[#94a3b8] text-base resize-none", value: campaign.description, onChange: function (e) {
                                            return handleChange(campaign.id, "description", e.target.value);
                                        }, placeholder: "Descreva o objetivo ou detalhes da campanha", maxLength: 255, rows: 2 })))),
                            campaign.is_active && descriptionChanged && (React.createElement("div", { className: "flex justify-center mt-6" },
                                React.createElement("button", { className: "bg-blue-600 hover:bg-blue-700 text-white rounded px-8 py-2 font-bold shadow transition", onClick: function () { return handleSave(campaign); } }, "Salvar")))));
                    })));
            }))));
};
export default DashboardSettings;
